import styled from 'styled-components'

export const Container = styled.div<any>`
  padding: 0 25px 1px;
  ${props => props.isWorking && `
    cursor: wait;
  `}

  button {
    display: block;
    font-size: 17px;
    width: 100%;
    margin: 0 0 40px;
    ${props => props.isWorking && `
      pointer-events: none;
    `}
  }
`

export const ReCAPTCHAContainer = styled.div`
  .grecaptcha-badge {
    z-index: 500;
  }
`
